(function () {
var $6ed8c3ab711979dd$export$31b89492673a65b7;
(function(QueryParamKeys) {
    QueryParamKeys["GET_SDK_CONFIG"] = "getSdkConfig";
    QueryParamKeys["IS_EMBEDDED"] = "embed";
    QueryParamKeys["PARENT_DOMAIN"] = "parentDomain";
})($6ed8c3ab711979dd$export$31b89492673a65b7 || ($6ed8c3ab711979dd$export$31b89492673a65b7 = {}));


var $a0ddda2ee5b9b5ef$export$8b7939210dfb437e;
(function(PostMessageEventName) {
    PostMessageEventName["CONFIG"] = "config";
    PostMessageEventName["CONFIG_REQUESTED"] = "configRequested";
})($a0ddda2ee5b9b5ef$export$8b7939210dfb437e || ($a0ddda2ee5b9b5ef$export$8b7939210dfb437e = {}));
var $a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba;
(function(ChatEmbedAttributes) {
    ChatEmbedAttributes["COLOR_MODE"] = "color-mode";
    ChatEmbedAttributes["PLAY_MESSAGE_SOUND"] = "play-message-sound";
    ChatEmbedAttributes["ROOM_NAME"] = "room";
    ChatEmbedAttributes["ROOT_URL"] = "root-url";
    ChatEmbedAttributes["USER_ID"] = "user-id";
    ChatEmbedAttributes["USER_NAME"] = "user-name";
})($a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba || ($a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba = {}));
const $a0ddda2ee5b9b5ef$export$c39407add348bd7b = (event)=>{
    const { data: data } = event;
    if (typeof data !== "object" || data === null) return false;
    if (!("name" in data && typeof data.name === "string")) return false;
    if (!("payload" in data && typeof data.payload === "object")) return false;
    return true;
};
const $a0ddda2ee5b9b5ef$export$fea1bdd0b083918d = (event)=>{
    const queryParams = new URLSearchParams(window.location.search);
    const parentDomain = queryParams.get((0, $6ed8c3ab711979dd$export$31b89492673a65b7).PARENT_DOMAIN);
    if (parentDomain === null) return false;
    const { origin: parentFrameOrigin } = new URL(decodeURIComponent(parentDomain));
    if (event.origin !== parentFrameOrigin) return false;
    if (!$a0ddda2ee5b9b5ef$export$c39407add348bd7b(event)) return false;
    if (event.data.name !== "config") return false;
    return true;
};



var $3c50f495607e7765$export$e9cc541a1d84538e;
(function(ColorMode) {
    ColorMode["DARK"] = "dark";
    ColorMode["LIGHT"] = "light";
})($3c50f495607e7765$export$e9cc541a1d84538e || ($3c50f495607e7765$export$e9cc541a1d84538e = {}));
const $3c50f495607e7765$var$ColorModeValueStrings = Object.values($3c50f495607e7765$export$e9cc541a1d84538e).map(String);
const $3c50f495607e7765$export$4a14e169b1de4ee7 = (color)=>{
    return $3c50f495607e7765$var$ColorModeValueStrings.includes(color);
};


const $5c69e7429e468bb9$export$ee741f9227bc3a7d = [
    "camera",
    "microphone",
    "display-capture",
    "fullscreen"
];


const $df18d55434a2a3da$export$3c7d50e43cfef2 = "https://chitchatter.im/" ?? "https://chitchatter.im/";
// NOTE: This is a subset of standard iframe attributes:
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attributes
const $df18d55434a2a3da$var$iframeAttributes = [
    "height",
    "referrerpolicy",
    "sandbox",
    "style",
    "width"
];
const $df18d55434a2a3da$var$configRequestTimeout = 10000;
class $df18d55434a2a3da$var$ChatEmbed extends HTMLElement {
    static get observedAttributes() {
        const chatAttributes = Object.values((0, $a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba));
        return [
            ...chatAttributes,
            ...$df18d55434a2a3da$var$iframeAttributes
        ];
    }
    get chatConfig() {
        const chatConfig = {};
        if (this.hasAttribute((0, $a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba).USER_ID)) chatConfig.userId = this.getAttribute((0, $a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba).USER_ID) ?? "";
        if (this.hasAttribute((0, $a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba).USER_NAME)) chatConfig.customUsername = this.getAttribute((0, $a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba).USER_NAME);
        chatConfig.playSoundOnNewMessage = Boolean(this.hasAttribute((0, $a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba).PLAY_MESSAGE_SOUND));
        const colorMode = this.getAttribute((0, $a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba).COLOR_MODE) ?? "";
        if ((0, $3c50f495607e7765$export$4a14e169b1de4ee7)(colorMode)) chatConfig.colorMode = colorMode;
        return chatConfig;
    }
    get rootUrl() {
        return this.getAttribute((0, $a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba).ROOT_URL) ?? $df18d55434a2a3da$export$3c7d50e43cfef2;
    }
    async listenForConfigRequest() {
        // NOTE: This cancels any pending config request listeners
        this.stopListeningForConfigRequest();
        window.addEventListener("message", this.handleConfigRequestedMessage);
        this.configRequestExpirationTimout = setTimeout(()=>{
            console.error(`[chitchatter-sdk] configuration was not sent successfully`);
            this.stopListeningForConfigRequest();
        }, $df18d55434a2a3da$var$configRequestTimeout);
    }
    updateIframeAttributes() {
        const { iframe: iframe } = this;
        const roomName = encodeURIComponent(this.getAttribute((0, $a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba).ROOM_NAME) ?? window.location.href);
        const urlParams = new URLSearchParams({
            [(0, $6ed8c3ab711979dd$export$31b89492673a65b7).IS_EMBEDDED]: "",
            [(0, $6ed8c3ab711979dd$export$31b89492673a65b7).GET_SDK_CONFIG]: "",
            [(0, $6ed8c3ab711979dd$export$31b89492673a65b7).PARENT_DOMAIN]: encodeURIComponent(window.location.origin)
        });
        const iframeSrc = new URL(this.rootUrl);
        iframeSrc.pathname = `public/${roomName}`;
        iframeSrc.search = urlParams.toString();
        const { href: src } = iframeSrc;
        // NOTE: Only update src if the value has changed to avoid reloading the
        // iframe unnecessarily.
        if (src !== iframe.getAttribute("src")) iframe.setAttribute("src", src);
        for (let attributeName of $df18d55434a2a3da$var$iframeAttributes){
            const attributeValue = this.getAttribute(attributeName);
            if (attributeValue !== null) iframe.setAttribute(attributeName, attributeValue);
        }
    }
    connectedCallback() {
        const shadow = this.attachShadow({
            mode: "open"
        });
        const { iframe: iframe } = this;
        iframe.style.border = "none";
        iframe.setAttribute("allow", (0, $5c69e7429e468bb9$export$ee741f9227bc3a7d).join(";"));
        shadow.appendChild(iframe);
        iframe.addEventListener("load", ()=>{
            this.listenForConfigRequest();
        });
    }
    disconnectedCallback() {
        this.stopListeningForConfigRequest();
    }
    attributeChangedCallback(name) {
        this.updateIframeAttributes();
        const isChatEmbedAttribute = Object.values((0, $a0ddda2ee5b9b5ef$export$ce054ddf7dff58ba)).map(String) // NOTE: Needed to avoid type warnings.
        .includes(name);
        if (isChatEmbedAttribute) this.sendConfigToChat();
    }
    constructor(...args){
        super(...args);
        this.configRequestExpirationTimout = null;
        this.iframe = document.createElement("iframe");
        this.sendConfigToChat = ()=>{
            const { iframe: iframe, rootUrl: rootUrl } = this;
            const { origin: rootUrlOrigin } = new URL(rootUrl);
            const postMessageEventData = {
                name: (0, $a0ddda2ee5b9b5ef$export$8b7939210dfb437e).CONFIG,
                payload: this.chatConfig
            };
            iframe.contentWindow?.postMessage(postMessageEventData, rootUrlOrigin);
        };
        this.handleConfigRequestedMessage = (event)=>{
            const { rootUrl: rootUrl } = this;
            const { origin: rootUrlOrigin } = new URL(rootUrl);
            if (rootUrlOrigin !== event.origin) return;
            if (!(0, $a0ddda2ee5b9b5ef$export$c39407add348bd7b)(event)) return;
            if (event.data.name !== (0, $a0ddda2ee5b9b5ef$export$8b7939210dfb437e).CONFIG_REQUESTED) return;
            this.sendConfigToChat();
            this.stopListeningForConfigRequest();
        };
        this.stopListeningForConfigRequest = ()=>{
            window.removeEventListener("message", this.handleConfigRequestedMessage);
            if (this.configRequestExpirationTimout !== null) {
                clearInterval(this.configRequestExpirationTimout);
                this.configRequestExpirationTimout = null;
            }
        };
    }
}
window.customElements.define("chat-room", $df18d55434a2a3da$var$ChatEmbed);

})();
//# sourceMappingURL=sdk.js.map
